import './index.module.scss';
import TermsView from '../../views/terms-view/terms-view';
import Head from 'next/head';

/* eslint-disable-next-line */
export interface TermsProps {}

export function Terms(props: TermsProps) {
  return (
    <>
      <Head>
        <title>利用規約 | BRiSK 適時開示</title>
      </Head>
      <TermsView />
    </>
  );
}

export default Terms;
